import { BillingStatus, OptionCode } from '../../enums';
import { InvoiceDetailItemKind, InvoiceKind, InvoiceStatus } from '../billing';
import mockedRequester from './mockedRequester';
export const mockedInvoiceDetailItem = {
    kind: InvoiceDetailItemKind.expert,
    userName: 'Foo',
    orgName: 'Bar',
    description: 'My invoice detail line',
    publicPrice: 100,
    subTotalPrice: 85,
    optionCode: OptionCode.waterBalanceArvalisMulti,
    membershipCode: 'CODE_MEMBER'
};
export const mockedInvoice = {
    kind: InvoiceKind.oneTime,
    reference: 'odoo556',
    status: InvoiceStatus.notPayed,
    invoiceDate: '1660050252',
    dueDate: '1667122852',
    paymentLink: 'https://pay.me',
    downloadLink: 'https://dl.me',
    amount: 100,
    amountWithTaxes: 120
};
export const mockedNextInvoice = {
    kind: InvoiceKind.anniversary,
    reference: null,
    status: null,
    invoiceDate: '1660050252',
    dueDate: '1667122852',
    amount: 100,
    amountWithTaxes: 120,
    detail: [mockedInvoiceDetailItem],
    paymentLink: null,
    downloadLink: null
};
export const mockedInvoices = [
    { ...mockedInvoice },
    {
        ...mockedInvoice,
        status: InvoiceStatus.payed,
        invoiceDate: '1660050252',
        dueDate: '1667122852',
        reference: 'odoo557'
    }
];
export const mockedBillingAccount = {
    addressLine1: '9 rue du test',
    addressLine2: 'RDC',
    city: 'TestVille',
    country: 'FR',
    id: 4,
    organizationName: 'Test SARL',
    organizationId: 124,
    siret: '12345678901234',
    zipCode: '44000',
    vatNumber: 'FRXX999999999'
};
export const mockedPaymentMethod = {
    id: 12,
    brand: 'visa',
    expirationMonth: 7,
    expirationYear: 2045,
    holderName: 'Test Test',
    last4Digits: '111'
};
export const mockedBillingStatus = {
    clientSecret: 'tressecret',
    id: 1
};
const planFeature = (active = true, params) => ({
    active,
    params: (params || null)
});
export const mockedPlanFeaturesByBilling = {
    essential: {
        'FEAT-DEVICEORG-CREATE': planFeature(false),
        'FEAT-HISTORY-VIEW': planFeature(false),
        'FEAT-CUMUL-VIEW': planFeature(false),
        'FEAT-INVITE-CREATE': planFeature(false),
        'FEAT-FORECAST-DATAREFRESH-FREQ': planFeature(true, 2),
        'FEAT-FORECAST-NUMDAYS': planFeature(true, 4),
        'FEAT-FORECAST-METRICS': planFeature(true, ['T', 'U', 'RR', 'FF', 'DD']),
        'FEAT-VIRTUAL-DEVICE': planFeature(true, { 0: 3, 2: 8 }),
        'FEAT-SPATIAL-DATAREFRESH-FREQ': planFeature(true, 6),
        'WEE-FEAT-OBSERVED-FILTERED-METRICS': planFeature(true, ['HPOT']),
        'FEAT-SPATIAL-FORECAST-MIX-0': planFeature(false),
        'FEAT-SPATIAL-NUMDAYS': planFeature(true, 1),
        'FEAT-SPATIAL-CALIBRATED': planFeature(false),
        'FEAT-SPATIAL-AGRO': planFeature(false),
        'WEE-FEAT-OBSERVED-VISIBLE': planFeature(false),
        'FEAT-WEATHERMAP-PLOT': planFeature(),
        'FEAT-WEATHERMAP-DEVICE': planFeature(false),
        'FEAT-ALERT-PREDICATE-OBSERVED': planFeature(false),
        'FEAT-ALERT-PREDICATE-FORECAST': planFeature(false),
        'FEAT-ALERT-GLOBAL': planFeature()
    },
    plus: {
        'FEAT-HISTORY-VIEW': planFeature(),
        'FEAT-CUMUL-VIEW': planFeature(),
        'FEAT-DEVICEORG-CREATE': planFeature(),
        'FEAT-INVITE-CREATE': planFeature(),
        'FEAT-FORECAST-DATAREFRESH-FREQ': planFeature(true, 6),
        'FEAT-FORECAST-NUMDAYS': planFeature(true, 15),
        'FEAT-FORECAST-METRICS': planFeature(true, ['T', 'U', 'RR', 'FF', 'DD', 'etp', 'T_SOIL']),
        'FEAT-VIRTUAL-DEVICE': planFeature(true, {
            '0': 2,
            '2': 2
        }),
        'FEAT-SPATIAL-DATAREFRESH-FREQ': planFeature(true, 24),
        'WEE-FEAT-OBSERVED-FILTERED-METRICS': planFeature(true, ['HPOT']),
        'FEAT-SPATIAL-NUMDAYS': planFeature(true, 1),
        'FEAT-SPATIAL-CALIBRATED': planFeature(false),
        'FEAT-SPATIAL-FORECAST-MIX-0': planFeature(),
        'FEAT-SPATIAL-AGRO': planFeature(),
        'WEE-FEAT-OBSERVED-VISIBLE': planFeature(false),
        'FEAT-WEATHERMAP-PLOT': planFeature(),
        'FEAT-WEATHERMAP-DEVICE': planFeature(),
        'FEAT-ALERT-PREDICATE-OBSERVED': planFeature(),
        'FEAT-ALERT-PREDICATE-FORECAST': planFeature(),
        'FEAT-ALERT-GLOBAL': planFeature()
    },
    expert: {
        'FEAT-DEVICEORG-CREATE': planFeature(),
        'FEAT-HISTORY-VIEW': planFeature(),
        'FEAT-CUMUL-VIEW': planFeature(),
        'FEAT-INVITE-CREATE': planFeature(),
        'FEAT-FORECAST-DATAREFRESH-FREQ': {
            active: true,
            params: 6
        },
        'FEAT-FORECAST-NUMDAYS': planFeature(true, 15),
        'FEAT-FORECAST-METRICS': planFeature(true, ['T', 'U', 'RR', 'FF', 'DD', 'etp', 'T_SOIL']),
        'FEAT-VIRTUAL-DEVICE': planFeature(true, {
            0: 15,
            2: 15
        }),
        'FEAT-SPATIAL-DATAREFRESH-FREQ': planFeature(true, 24),
        'WEE-FEAT-OBSERVED-FILTERED-METRICS': planFeature(true, []),
        'FEAT-SPATIAL-NUMDAYS': planFeature(),
        'FEAT-SPATIAL-CALIBRATED': planFeature(false),
        'FEAT-SPATIAL-FORECAST-MIX-0': planFeature(),
        'FEAT-SPATIAL-AGRO': planFeature(),
        'WEE-FEAT-OBSERVED-VISIBLE': planFeature(),
        'FEAT-WEATHERMAP-PLOT': planFeature(),
        'FEAT-WEATHERMAP-DEVICE': planFeature(),
        'FEAT-ALERT-PREDICATE-OBSERVED': planFeature(),
        'FEAT-ALERT-PREDICATE-FORECAST': planFeature(),
        'FEAT-ALERT-GLOBAL': planFeature()
    }
};
export const mockedCurrentPlan = {
    billingStatus: BillingStatus.expert,
    licencesCount: 8,
    priceWithTaxes: 882,
    price: 840,
    reference: 'odoo',
    startDate: '1660122744',
    renewalDate: '1660222744',
    detail: {
        [BillingStatus.expert]: {
            licencesCount: 4,
            unitPublicPrice: 100,
            unitDiscountPrice: 90,
            priceSubTotal: 360
        },
        [BillingStatus.plus]: {
            licencesCount: 4,
            unitPublicPrice: 200,
            unitDiscountPrice: 120,
            priceSubTotal: 480
        }
    }
};
const mockedPaymentIncident = {
    paymentDueDate: new Date(2035, 10, 5).getTime()
};
const mockedSubscriptionPricesDetails = {
    billingStatus: BillingStatus.expert,
    taxlessPrice: 300,
    totalPrice: 360
};
export const mockedUpgradeNetOrgSubscriptionPrices = {
    sumTaxlessPrice: 123.34,
    sumTotalPrice: 148,
    linesByUser: [
        {
            previousPlanDateStart: new Date(2034, 10, 5).getTime(),
            creditDateStart: new Date(2035, 8, 5).getTime(),
            creditDateEnd: new Date(2035, 10, 5).getTime(),
            name: 'Foo Bar',
            consumed: {
                status: 3,
                priceUnit: 300.0,
                priceSubtotal: 280.32,
                priceTotal: 336.38,
                tax: 20.0
            },
            unconsumed: {
                status: null,
                priceUnit: 168.0,
                priceSubtotal: -156.98,
                priceTotal: -188.38,
                tax: 20.0
            }
        }
    ]
};
export const mockedSubscriptionOrder = {
    billingStatus: BillingStatus.expert,
    saleOrderId: 3,
    paymentLink: 'https://weenat-preprod-app.odoo.com/payment/pay?reference=CMD19620&amount=201.6&sale_order_id=20639&access_token=13e71d76e90ecbd80457362d54e056fcea47661c283ad86385af86c2fc28b0a2',
    priceSubtotal: 170,
    priceTotal: 200
};
const mock = {
    sendPlanSubscribeMail: mockedRequester({}, 'billing.sendPlanSubscribeMail'),
    sendPlanUnsubscribeMail: mockedRequester({}, 'billing.sendPlanUnsubscribeMail'),
    getPlanFeaturesByBilling: mockedRequester(mockedPlanFeaturesByBilling, 'billing.getPlanFeaturesByBilling'),
    confirm: mockedRequester(mockedPaymentMethod, 'billing.confirm'),
    editAccount: mockedRequester(mockedBillingAccount, 'billing.editAccount'),
    getAccount: mockedRequester(mockedBillingAccount, 'billing.getAccount'),
    getPaymentMethods: mockedRequester([mockedPaymentMethod], 'billing.getPaymentMethods'),
    upgrade: mockedRequester(undefined, 'billing.upgrade'),
    getInvoices: mockedRequester(mockedInvoices, 'billing.getInvoices'),
    getNextInvoice: mockedRequester(mockedNextInvoice, 'billing.getNextInvoice'),
    deletePaymentMethod: mockedRequester(undefined, 'billing.deletePaymentMethod'),
    getCurrentPlan: mockedRequester(mockedCurrentPlan, 'billing.getCurrentPlan'),
    getPaymentIncident: mockedRequester(mockedPaymentIncident, 'billing.getPaymentIncident'),
    getUpgradeNetOrgSubscriptionPrices: mockedRequester(mockedUpgradeNetOrgSubscriptionPrices, 'billing.getUpgradeNetOrgSubscriptionPrices'),
    getSubscriptionPrices: mockedRequester([mockedSubscriptionPricesDetails], 'billing.getSubscriptionPrices'),
    getSubscriptionOrder: mockedRequester(mockedSubscriptionOrder, 'billing.getSubscriptionOrder')
};
export default mock;
